import React, { useEffect, useState } from "react";
import { subscribeLoading } from "@/lib/loadingBar";
import { useI18n } from "@/i18n/I18nContext";

// Solo aparece si la carga dura más que esto: las rápidas no parpadean.
const SHOW_DELAY_MS = 150;
const TRICKLE_MS = 250;

// Barra fina en lo alto de la pantalla mientras hay algo cargando (ver
// lib/loadingBar.js). Verde lima: el verde de marca no se ve sobre la
// cabecera, que también es verde. No sabemos cuánto falta, así que avanza cada vez más
// despacio hacia el 90 % y salta al 100 % al terminar.
const TopProgressBar = () => {
  const { t } = useI18n();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // idle → waiting (retraso antes de mostrarse) → running (avanzando)
    // → finishing (al 100 % y desvaneciéndose) → idle
    const st = { phase: "idle", show: null, trickle: null, hide: null };
    const startRunning = (from) => {
      st.phase = "running";
      setVisible(true);
      setProgress(from);
      st.trickle = setInterval(() => setProgress((p) => p + (90 - p) * 0.12), TRICKLE_MS);
    };
    const unsubscribe = subscribeLoading((pending) => {
      if (pending > 0) {
        if (st.phase === "idle") {
          st.phase = "waiting";
          st.show = setTimeout(() => startRunning(10), SHOW_DELAY_MS);
        } else if (st.phase === "finishing") {
          // Otra carga mientras se cerraba la anterior: sigue la misma barra.
          clearTimeout(st.hide);
          startRunning(30);
        }
      } else if (st.phase === "waiting") {
        clearTimeout(st.show);
        st.phase = "idle";
      } else if (st.phase === "running") {
        clearInterval(st.trickle);
        st.phase = "finishing";
        setProgress(100);
        st.hide = setTimeout(() => {
          st.phase = "idle";
          setVisible(false);
          setProgress(0);
        }, 350);
      }
    });
    return () => {
      unsubscribe();
      clearTimeout(st.show);
      clearInterval(st.trickle);
      clearTimeout(st.hide);
    };
  }, []);

  if (!visible) return null;
  return (
    <div
      data-testid="top-progress"
      role="progressbar"
      aria-label={t("common.loading")}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(progress)}
      className="fixed inset-x-0 top-0 z-[9999] h-[3px] pointer-events-none"
    >
      <div
        className="h-full bg-lime-400 border-b border-emerald-800/40 shadow-[0_0_10px_rgba(163,230,53,0.8)] transition-[width,opacity] duration-300 ease-out motion-reduce:transition-none"
        style={{ width: `${progress}%`, opacity: progress >= 100 ? 0 : 1 }}
      />
    </div>
  );
};

export default TopProgressBar;
